import { Validators, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { DOCUMENT } from '@angular/common';
import { AfterContentChecked, AfterContentInit, AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import DadosCertificadoModel from '../model/dados-certificado.model';
import { ModalContratoComponent } from './../modal-contrato/modal-contrato.component';
import { DadosContratosModel } from './../model/dados-contrato.model';
import { CertificadoService } from './../services/certificado.service';
import { RegistroService } from './../services/registro.service';
import { PerfisServicosModel } from '../model/perfis-servicos.model';
import { ServicoModel } from '../model/servico.model';
import Utils from '../utils/utils';
import { DadosTermoPerfilMock } from '../mock/termo-contrato-registro-mock';
import { DadosGravaModel } from '../model/dados-grava.model';
import DadosRegistroModel from '../model/dados-registro.model';
import { ModalMensagemComponent } from './../modal-mensagem/modal-mensagem.component';
import { AppComponent } from './../app.component';

@Component({
  selector: 'app-novo-registro',
  templateUrl: './novo-registro.component.html',
  styleUrls: ['./novo-registro.component.css']
})
export class NovoRegistroComponent implements OnInit {

  @ViewChild('contrato') myDiv: ElementRef;
  registroForm: FormGroup;

  public dadosCertificado: DadosCertificadoModel;
  public dadosRegistro: DadosRegistroModel;
  public permiteRegistro: boolean = false;
  private dadosContrato: any;
  private perfilSelecionado: PerfisServicosModel;
  private termoMock: DadosTermoPerfilMock = new DadosTermoPerfilMock();
  public numeroContrato: number;
  tipoChancela: number;
  bntHabilitado: boolean = false;
  eCaepf: boolean = false;


  constructor(private fb: FormBuilder,
    @Inject(DOCUMENT) private document: Document,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private certificadoService: CertificadoService,
    private registroService: RegistroService,
    private appComponent: AppComponent
  ) { }

  ngOnInit() {

    setTimeout(() => this.certificadoService.OnInit(), 1000);
    setTimeout(() => this.registroService.OnInit(), 1000);
    this.autenticacoesCertificado();
    this.createForm();
    this.obterParamCertificadoCaepf();

  }


  private createForm() {
    this.registroForm = this.fb.group(
      {
        cmbPerfil: new FormControl(),
        chkContrato: [false, Validators.pattern('true')],
        contrato: '',
        nuCeiDigitado: ['', Validators.required]

      });
    this.eCaepf = false;
  }

  get possuiRegistro(): boolean {
    return undefined !== this.dadosRegistro && null !== this.dadosRegistro;
  }

  private async obterToken() {
    //token vazio
    // if (!sessionStorage['token'])
      await this.certificadoService.obterToken().then(token => {
        sessionStorage['token'] = token; //grava na sessao..
        return token;
      });
    // else
    //   //token
    //   return sessionStorage['token'];
  }

  private async trataSituacao() {

    if (this.dadosRegistro !== undefined) {
      await this.certificadoService.trataRegistroInvalido(this.dadosRegistro.situacao);
      this.router.navigate(['/acesso-negado']);
    }

  }

  trataDadostelaCaepf() {
    const valido = this.dadosCertificado.caepf ? 0 : 1;
    this.eCaepf = valido === 0 ? true : false;
    if (this.dadosRegistro.nu_inscricao != null && this.eCaepf)
      
      this.nuCeiDigitado.setValue(this.dadosRegistro.nu_inscricao.substring(3, 15));
  }

  private async atualizaSessaoUsuario() {
    sessionStorage['dadosCertificado'] = JSON.stringify(this.dadosCertificado);
    sessionStorage['dadosRegistro'] = JSON.stringify(this.dadosRegistro);
  }

  async autenticacoesCertificado() {

    //grava token da sessao do certificado
    await this.obterToken().then(token => {     
    });
    //obtem certificado
    if (!sessionStorage['dadosCertificado']) {
      await this.certificadoService.obterCertificadoPorToken().then(certificado => {
        this.dadosCertificado = certificado;
      })
        .catch(err => {
          console.error(err);
        });
    } else {
      this.dadosCertificado = JSON.parse(sessionStorage['dadosCertificado']);
    }

    if (0 === +this.dadosCertificado.inscricao){
      this.dadosCertificado.caepf = true;
    }

    let certValido = false;
    //valida cetificado
    await this.certificadoService.validaCertificado(this.dadosCertificado).then(isValido => {
      if (!isValido)
        certValido = true;
    }).catch(err => {
      console.log('erro validaCertificado(): ' + err)
    });

    if (certValido) {
      // Verifica Situacao da Inscricao
      await this.registroService.consultarSituacaoRegistro(this.dadosCertificado).subscribe(
        data => {
          if (data && data['data']) {
            this.setardadosRegistro(data);
            this.registroService.isInscricaoBloqueada(this.dadosRegistro);

            if (this.dadosRegistro.nu_inscricao > '0') {

              if (!this.dadosRegistro.bloqueado  && (this.dadosRegistro.situacao !== 4 && this.dadosRegistro.situacao !== 3)) {

                this.trataSituacao();

              } else {

                if (this.dadosRegistro.situacao === 4 || this.dadosRegistro.situacao === 3) { //Revogado
                  this.mostraDialogMensagem();
                }
                this.trataDadostelaCaepf();
                this.permiteRegistro = true;
              }

            } else {
              this.trataDadostelaCaepf();
              this.permiteRegistro = true;
            }


          }
          this.atualizaSessaoUsuario();
        }
        , err => {
          console.error(err);
        }
      );
    }


  }

 setardadosRegistro(data) {
    this.dadosRegistro = new DadosRegistroModel();
    this.dadosRegistro.bloqueado = data['data']['bloqueado']===null || data['data']['bloqueado']==='0'? false:true ;
    this.dadosRegistro.situacao =  Number(data['data']['situacao']);
    this.dadosRegistro.nu_certificado = Number(data['data']['nuCertificado']);
    this.dadosRegistro.no_responsavel = data['data']['noResponsavel'];
    this.dadosRegistro.nu_cpf = Number(data['data']['nuCpf']);
    this.dadosRegistro.co_certificado= data['data']['coCertificado'];
    this.dadosRegistro.de_nome_comum= data['data']['deNomeComun'];
    this.dadosRegistro.no_autoridade_certificadora= data['data']['noAutoridadeCertificadora'];
    this.dadosRegistro.nu_perfil= Number(data['data']['nuPerfil']);
    this.dadosRegistro.nu_pis= Number(data['data']['nuPis']);
    this.dadosRegistro.nu_entidade_certificada= Number(data['data']['nuEntidadeCertificada']);
    this.dadosRegistro.de_razao_social= data['data']['deRazaoSocial'];
    this.dadosRegistro.nu_inscricao= data['data']['nuInscricao'];
    this.dadosRegistro.de_perfil= data['data']['dePerfil'];
    this.dadosRegistro.ic_tipo_perfil= Number(data['data']['icTipoPerfil']);
    this.dadosRegistro.ic_tipo_restricao= Number(data['data']['icTipoRestricao']);

  }

  atualizaPerfil(novoPerfil: PerfisServicosModel) {
    // console.log("novoPerfil[0] ::", novoPerfil[0]);
    this.perfilSelecionado = novoPerfil[0];
  }

  get nuCeiDigitado() {
    return this.registroForm.get("nuCeiDigitado");
  }

  get isCEIValido() {
    if (this.nuCeiDigitado == null || this.nuCeiDigitado.value == "") {
      return true;
    } else {
      return Utils.validaCei(Utils.unmaskInscricao(this.nuCeiDigitado.value));
    }
  }

  //Contrato aceito
  get chkContrato() {
    return this.registroForm.get("chkContrato").value;
  }

  get isPerfilValido() {
    return this.perfilSelecionado !== undefined && this.perfilSelecionado.isValido;
  }

  get mostraCheckContrato() {
    return this.isPerfilValido;
  }

  get mostraBtnRegistrar() {

    if (!this.dadosCertificado.caepf)
      return this.isPerfilValido && this.chkContrato;
    else
      return this.isPerfilValido && this.chkContrato && this.verificarCeiValido();
  }

  verificarCeiValido() {
    if (this.nuCeiDigitado == null || this.nuCeiDigitado.value == "") {
      return false;
    }
    if (Utils.validaCei(Utils.unmaskInscricao(this.nuCeiDigitado.value))) {
      this.dadosCertificado.inscricao = this.nuCeiDigitado.value;
      return true;
    }

  }

  get habilitaBtn(): boolean {
    return this.bntHabilitado;
  }

  /**
  * Exibe modal com Mensagem.
  */
  mostraDialogMensagem() {
    if (this.dialog.openDialogs.length == 0) {
      const dadosRegistro = this.dadosRegistro;
      this.dialog.open(ModalMensagemComponent, {
        width: '750px',
        data: { dadosRegistro, titulo: 'Mensagem do Sistema' }
      });
    }
  }

  //metodo auxilar do Contrato..
  private obterContrato(modal) {
    if (modal)
      return this.myDiv.nativeElement.innerHTML
    else
      return this.myDiv.nativeElement.innerText;
  }

  //metodo auxilar do Contrato..
  private obterDescricaoPerfil() {
    return this.perfilSelecionado.descPerfil;
  }

  //monta lista de Serviços do Contrato..
  private obterListaServicos() {

    //servico
    let servico = new ServicoModel();
    const listaServicos: string[] = [];

    this.perfilSelecionado.grupos.map((item) => {
      item.servicos.map((itemServico) => {
        servico.nuServico = itemServico.idServico;
        servico.deServico = itemServico.descServico;
        listaServicos.push(servico.deServico);
      });
    });
    return listaServicos;
  }

  obterTipoContrato() {
    return this.perfilSelecionado.tipoNovoRestricao != "0" ? "RESTRITO" : "AMPLO";
  }

  async setardadosContrato() {
    this.dadosContrato = new DadosContratosModel();
    this.dadosContrato.titulo = 'Contrato';
    this.dadosContrato.contrato = this.obterContrato(true);
    this.dadosContrato.desPerfil = this.obterDescricaoPerfil();
    this.dadosContrato.inscricao = this.dadosCertificado.inscricao;
    this.dadosContrato.razaoSocial = this.dadosCertificado.razaoSocial;
    this.dadosContrato.tipoInscricao = this.dadosCertificado.tpInscricao;
    this.dadosContrato.servicos = this.obterListaServicos();
    this.dadosContrato.tipoContrato = this.obterTipoContrato();
  }



  /**
   * Exibe modal com Contrato.
   */
  mostraDialogContrato() {
    this.setardadosContrato().then(() => {
      const dadosContratos = this.dadosContrato;
      if (this.isPerfilValido) {
        this.dialog.open(ModalContratoComponent, {
          width: '750px',
          data: { dadosContratos, titulo: 'Contrato' }
        });
      }
    });
  }



  //Action do link Contrato..
  lerTermo() {
    this.mostraDialogContrato();
  }

  async registrar() {

    if(this.verificaInstalacaoCriptocnsKry()){
    this.bntHabilitado = true;
    this.setardadosContrato();
    
    const termoTxt = this.dadosContrato.tipoInscricao === '3' ? this.termoMock.textoTermoAceiteFisico(this.dadosContrato) :
    this.termoMock.textoTermoAceiteJuridico(this.dadosContrato);

    const termoAssinado = await this.certificadoService.assinarCriptoCns(this.dadosCertificado, termoTxt, false);
  
    if (termoAssinado)
      this.grava(termoAssinado, termoTxt);
    else
      this.bntHabilitado = false;
  }
}

  get isPerfilRestrito(): boolean {
    const restrito =
      this.perfilSelecionado !== null &&
      this.perfilSelecionado.tipoPerfil == '2' &&
      this.perfilSelecionado.tipoRestricao == '1';
    return restrito;
  }

  async grava(assinatura: any, contrato: any) {

    if(this.verificaInstalacaoCriptocnsKry()){

    let parametersGrava = new DadosGravaModel();   
   let pem = assinatura;
   
    if (this.nuCeiDigitado.value != "") {
      const caepf: number = +this.montaCaepf(this.dadosCertificado.cpfResponsavel + '');
      parametersGrava.caepf = caepf;
      parametersGrava.numInscricao = this.nuCeiDigitado.value;
    }
    if (this.isPerfilRestrito) {
      parametersGrava.ultimoTipoChancela = 1;
      parametersGrava.tipoChancela = 1; //PRE-AUTORIZADO
      this.tipoChancela = 1;
    } else {
      parametersGrava.ultimoTipoChancela = 2;
      parametersGrava.tipoChancela = 2; //AUTORIZACAO AUTOMATICA
      this.tipoChancela = 2;
    }
    parametersGrava.numPerfil = +this.perfilSelecionado.idPerfil;
    parametersGrava.tipoContrato = 1;
    parametersGrava.imagemChancela = contrato.toString();
    parametersGrava.imagemAssinatura = pem;
    parametersGrava.imagemAssinaturaSistema = pem;


    const servicos: string[] = this.obterNumeroServicos();
    parametersGrava.servicos = servicos;

    await this.registroService.grava(parametersGrava).then(data => {
      const mensagem = data['status'];
      if (mensagem == "200") {
        this.atualizaSessaoUsuario();
        this.numeroContrato = data['numeroContrato'];
        this.router.navigate(['sucesso', this.numeroContrato, this.tipoChancela, 'registrar',this.perfilSelecionado.idPerfil ]);
      }
    });

  }
  }

  private montaCaepf(cpf: string) {

    let caepf: string
    while (cpf.length < 11) {
      cpf = "0" + cpf;
    }
    caepf = cpf.substr(0, 9);
    caepf = caepf + "001";
    return caepf;
  }

  obterNumeroServicos() {

    const nuServico: string[] = [];
    this.perfilSelecionado.grupos.map((item) => {
      item.servicos.map((itemServico) => {
        nuServico.push(itemServico.idServico);
      });
    });
    return nuServico;
  }

  private obterParamCertificadoCaepf() {

    if (this.route.snapshot.paramMap.get('CertificadoCaepf') !== null) {
      let valido = +this.route.snapshot.paramMap.get('CertificadoCaepf');
      let inscricao = this.route.snapshot.paramMap.get('inscricao');
      this.eCaepf = valido === 0 ? true : false;
      this.nuCeiDigitado.setValue(inscricao.toString().substring(3, 15));
    }

  }

  get readonlyCaepf() {
    return this.dadosRegistro.nu_inscricao != null && this.eCaepf;
  }

  async verificaInstalacaoCriptocnsKry(){
 
    return await this.appComponent.verificaAPICriptoCNS();
  }

}
